import { Component, OnInit } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { ManagerEmployeeService } from "../../../services/employees/manager-employees.service";
import { Subject, takeUntil } from "rxjs";
import { RemoveEmployeeFromVenueModel } from "../../../models/employees/remove-employee-from-venue.model";
import { MessageService } from "primeng/api";

@Component({
  selector: 'app-delete-manager-employee',
  templateUrl: './delete-manager-employee.component.html',
  styleUrls: ['./delete-manager-employee.component.scss']
})
export class DeleteManagerEmployeeComponent implements OnInit {

  //#region Fields
  public userId: string;
  public venueId: string;
  public unsubscribe: Subject<void> = new Subject<void>();
  public spinner: boolean = false;
  //#endregion

  //#region Constructor
  constructor(private config: DynamicDialogConfig,
              private ref: DynamicDialogRef,
              private employeeService: ManagerEmployeeService,
              public messageService: MessageService) {
    if (this.config.data != undefined && this.config.data.id && this.config.data.venueId) {
      this.userId = this.config.data.id;
      this.venueId = this.config.data.venueId;
    }
  }

  ngOnInit(): void {
  }
  //#endregion

  //#region Public Methods
  removeEmployeeFromVenue() {
    let deleteEmployeeModel = new RemoveEmployeeFromVenueModel();
    deleteEmployeeModel.employeeId = this.userId;
    deleteEmployeeModel.venueId = this.venueId;

    this.spinner = true;
    this.employeeService.removeEmployeeFromVenues(deleteEmployeeModel)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe({
        next: (response) => {
          this.ref.close(true)
        },
        error: errorResponse => {
          this.spinner = false;
          this.messageService.add({ severity: 'error', summary: "System error", life: 2000 });
        }
      });
  }

  cancel(): void {
    this.ref.close(false);
  }
  //#endregion
}
